export const SurveySectionInstruction = (props: { instruction: string }) => {
  const { instruction } = props;
  return <div className="survey-section__instruction">{instruction}</div>;
};
